import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'components/AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - Ported Pages
const SurveyMonitor = Loadable(lazy(() => import('pages/survey-monitor')));
const FarmerTracker = Loadable(lazy(() => import('pages/farmer-tracker')));
const FarmersDatabaseTab = Loadable(lazy(() => import('pages/farmers-db')));
const AnalyticsDashboard = Loadable(lazy(() => import('pages/analytics')));
const SurveySetup = Loadable(lazy(() => import('pages/survey-setup')));

// Extra pages
const AIChatPage = Loadable(lazy(() => import('pages/ai-chat')));
const QCAudioPage = Loadable(lazy(() => import('pages/qc-audio')));
const SettingsPage = Loadable(lazy(() => import('pages/settings')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    { path: 'survey-monitor', element: <SurveyMonitor /> },
    { path: 'farmer-invite', element: <FarmerTracker /> },
    { path: 'farmer-tracker', element: <FarmerTracker /> },
    { path: 'farmers-db', element: <FarmersDatabaseTab /> },
    { path: 'analytics', element: <AnalyticsDashboard /> },
    { path: 'survey-setup', element: <SurveySetup /> },
    { path: 'ai-chat', element: <AIChatPage /> },
    { path: 'qc-audio', element: <QCAudioPage /> },
    { path: 'settings', element: <SettingsPage /> }
  ]
};

export default MainRoutes;
